import { MeasureApplicableContext } from '@adtrackify/at-tracking-event-types';

import { createTableColumnsStore } from '@/store/tables/create-table-columns-store';
import { DEFAULT_PNL_COLUMNS } from '../constants/pnl-table-columns-constants';

export const usePnlTableColumnsStore = createTableColumnsStore(
  'pnl-table',
  DEFAULT_PNL_COLUMNS,
  {
    version: 1,
    context: MeasureApplicableContext.CUSTOM_DASHBOARD,
  }
);
